import { v4 as uuid } from 'uuid'
import { bucket } from '../../firebase/config'
import { client } from '../../hooks/Client'

/**
 * Zet een bestand in de opslag en geeft de downloadlink terug.
 *
 * De link wordt daarna als waarde van het gegevensveld bewaard — zo werkt een
 * geüpload document dat via het intakeformulier binnenkomt ook, dus de
 * gegevenstabel kan beide op dezelfde manier tonen.
 *
 * Het pad draagt de omgeving, zodat bestanden van verschillende organisaties
 * nooit in dezelfde map belanden.
 *
 * AI-CONTEXT: See docs/features/gegevensveld-types.md
 *
 * @param {object} params
 * @param {File} params.file - Het gekozen bestand
 * @param {string} params.ownerId - Het huishouden of de deelnemer waar het bij hoort
 * @param {(percentage: number) => void} [params.onProgress] - Krijgt de voortgang
 * @returns {Promise<string>} de downloadlink
 */
const uploadDataFieldFile = ({ file, ownerId, onProgress }) => new Promise((resolve, reject) => {
    if (!file || !ownerId) {
        reject(new Error('Uploaden kan niet zonder bestand en eigenaar.'))
        return
    }

    const veiligeNaam = `${uuid()}-${file.name}`
    const ref = bucket.ref(`dataFields/${client}/${ownerId}/${veiligeNaam}`)
    const taak = ref.put(file)

    taak.on(
        'state_changed',
        (snap) => {
            if (onProgress && snap?.totalBytes) {
                onProgress((snap.bytesTransferred / snap.totalBytes) * 100)
            }
        },
        // Doorgooien en niet stil een lege link teruggeven: dat zou het
        // gegeven leegmaken zonder dat iemand het merkt.
        reject,
        async () => {
            try {
                resolve(await taak.snapshot.ref.getDownloadURL())
            } catch (err) {
                reject(err)
            }
        }
    )
})

export default uploadDataFieldFile
